import { zodResolver } from '@hookform/resolvers/zod';
import type { ContractPageData } from '@weft/api-definition';
import type { Plan } from '@weft/types';
import { DEFAULT_CURRENCY, PlanInputSchema } from '@weft/types';
import { withDefault } from '@weft/utils';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { PlanCharges } from '../../plans/PlanViewPage/plan-view-page-components/PlanCharges';
import { ContractPageDetails } from './ContractPageDetails';

type ContractPageContentViewProps = {
  contractPageData: ContractPageData;
};

export const ContractPageContentView: React.FC<ContractPageContentViewProps> = ({ contractPageData }) => {
  const methods = useForm<Plan>({
    resolver: zodResolver(PlanInputSchema),
    defaultValues: contractPageData.contract.plan,
  });

  const { contract } = contractPageData;
  const currency = withDefault(contract.customer.settings?.currency, DEFAULT_CURRENCY);

  return (
    <FormProvider {...methods}>
      <div className="grow bg-[#F5F5F5]">
        <div className="mx-auto max-w-screen-xl">
          <ContractPageDetails
            billingData={contract.plan.billingData}
            revenue={contract.revenue}
            contractStartDate={contract.startDate}
            customerName={contract.customer.name}
            customerId={contract.customer.id}
            currency={currency}
            products={contract.plan.products}
            contractId={contract.id}
            plan={contract.plan}
            contractSyncStatus={contract.syncStatus}
            contractSyncStatusUpdatedAt={contract.syncStatusUpdatedAt}
          />

          <PlanCharges
            plan={contract.plan}
            currency={currency}
          />
        </div>
      </div>
    </FormProvider>
  );
};